import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatTooltipModule } from '@angular/material';
import { RouterModule } from '@angular/router';
import { SpreadSheetsModule } from '@grapecity/spread-sheets-angular';
import { WindowModule } from '@progress/kendo-angular-dialog';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { PagerModule } from '@progress/kendo-angular-pager';
import { ImportConflictsComponent } from './import-conflicts/import-conflicts.component';
import { ImportDialogComponent } from './import-dialog/import-dialog.component';
import { OpenImportDialogDirective } from './open-import-dialog.directive';

@NgModule({
  declarations: [ImportDialogComponent, ImportConflictsComponent, OpenImportDialogDirective],
  entryComponents: [ImportDialogComponent, ImportConflictsComponent],
  imports: [
    CommonModule,
    MatTooltipModule,
    MatDialogModule,
    WindowModule,
    PagerModule,
    RouterModule,
    SpreadSheetsModule,
    InputsModule,
    FormsModule,
    LabelModule
  ],
  exports: [ImportDialogComponent, OpenImportDialogDirective]
})
export class ImportDialogModule {}
